<template>
  <button class="btn bg-light-white w-40" @click="$emit('click')">
    <em class="fas fa-file-plus pr-2 text-green" />
    <span class="text-button-add-document">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'OpenButton',
  props: {
    text: String,
  },
};
</script>
